/**
 * Constants - Constantes centralizadas del sensor
 * 
 * Define todos los valores constantes: niveles de severidad, modos de operación,
 * tipos de eventos, acciones tomadas, valores por defecto y mensajes de error.
 */

export const ADR_CONSTANTS = {
	SEVERITY: {
		LOW: 'low',
		MEDIUM: 'medium',
		HIGH: 'high',
		CRITICAL: 'critical'
	},
	MODES: {
		OBSERVE: 'observe',
		BLOCK: 'block',
		REPORT: 'report'
	},
	EVENT_TYPES: {
		XSS: 'xss',
		CSRF: 'csrf',
		INJECTION: 'injection',
		ANOMALY: 'anomaly',
		SYSTEM: 'system',
		SSRF: 'ssrf',
		OPEN_REDIRECT: 'open_redirect',
		NOSQL_INJECTION: 'nosql_injection',
		PROTOTYPE_POLLUTION: 'prototype_pollution'
	},
	ACTION_TAKEN: {
		LOGGED: 'logged',
		BLOCKED: 'blocked',
		SANITIZED: 'sanitized',
		NONE: 'none'
	},
		DEFAULTS: {
			// API base URL (portal) for cross-origin setups.
			portalBaseUrl: '__SENSOR_PORTAL_BASE_URL__',
			apiBaseUrl: '',
			endpoint: '/api/adr/events',
			scriptIntegrityEndpoint: '/api/adr/script-integrity',

			// Session-token (JWT) flow
			profileId: '',
			tokenEndpoint: '/api/adr/session-token',
			sessionTokenRefreshWindowSeconds: 300,
			sessionTokenFailureBackoffSeconds: 10,

			mode: 'observe',
			minSeverity: 'medium',
			flushIntervalMs: 1000,
			maxRetries: 3,
			retryDelays: [1000, 2000, 4000],
			timeout: 15000,
			debug: false,
			xssDetectionEnabled: true,
			csrfDetectionEnabled: true,
			injectionDetectionEnabled: true,
			injectionDedupeTtlMs: 60000,
			injectionMaxPerMinute: 10,
			injectionEvidenceMaxLen: 256,
			injectionRedactEnabled: true,
			injectionDebug: false,
			csrfDedupeTtlMs: 60000,
			csrfMaxPerMinute: 10,
			xssMaxPerMinute: 10,
			scriptIntegrityEnabled: true,
			scriptIntegrityMaxReportsPerMin: 60,
			scriptIntegrityDebounceMs: 500,
			scriptIntegrityDedupeStorage: 'session',
			scriptIntegrityDedupeTtlMs: 24 * 60 * 60 * 1000, // 24h
			scriptIntegrityDedupeMaxEntries: 500,
			scriptIntegrityDedupeKeyPrefix: 'adr_sri_v1',
			maxQueueSize: 1000
	},
	ERRORS: {
		NO_ENDPOINT: 'Endpoint is required',
		NO_PROFILE_ID: 'Profile ID is required',
		NO_TOKEN_ENDPOINT: 'Token endpoint is required',
		NO_PORTAL_BASE_URL: 'portalBaseUrl/apiBaseUrl is required when using relative endpoints',
		INVALID_SEVERITY: 'Invalid severity level',
		INVALID_MODE: 'Invalid mode'
	}
};

export default ADR_CONSTANTS;

